// removed by extract-text-webpack-plugin
module.exports = {"container":"_3N8ARSIva62URt-2JChqEB","inner":"b78V5l0yvZMlP8lPN4LCQ","header":"_1MAkNT1-icgVK2KTzkHM0y UiOtkwjAwJvCk7RAufbT2","uvp":"_2UCvn1svH-gOrXMJg24jHN","link":"_31qwm17cUo8MALRxwzQN6f","sub-header":"O1WF0lY122WS7Cj4tL8Hy _2F-JnOTAU3pAH0PO-2EJ0i"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/HomeWhat.scss
// module id = 1171
// module chunks = 47